angular.module("Main").controller("ShopFailController", ["$rootScope", "$scope", "$state", "$window", "$stateParams", "$location", "$translate", "$uibModal", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $window, $stateParams, $location, $translate, $uibModal, PaymentService, BookingService, SessionService) {
        var vm = this;


        getKursbuchungLayouKonfiguration();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'shopData');
            //unregisterEventHandler();
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});

        });
        BookingService.getCurrency().then(function (data) {
            vm.currency = data;
            if (vm.currency.Waehrung === "EUR")
                vm.currency.Waehrung = "€";
        });

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;


        if (!SessionService.getSessionId()) {
            $state.go("shop", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        }

    }])